






























































import { Component, Prop, Vue } from "vue-property-decorator";
import { Shop, Address } from "../../api/types";

@Component({
  name: "ShopInfo"
})
export default class extends Vue {
  @Prop() private shop!: Shop;

  private days = [
    {
      key: "monday",
      text: "Monday"
    },
    {
      key: "tuesday",
      text: "Tuesday"
    },
    {
      key: "wednesday",
      text: "Wednesday"
    },
    {
      key: "thursday",
      text: "Thursday"
    },
    {
      key: "friday",
      text: "Friday"
    },
    {
      key: "saturday",
      text: "Saturday"
    },
    {
      key: "sunday",
      text: "Sunday"
    }
  ];

  get displayedAddress(): string {
    const {
      line1,
      line2,
      line3,
      district,
      region,
      postcode
    }: Address = this.shop.address;
    const addressDetails = [line1, line2, line3, district, region, postcode];
    const addressDetailsNotNull = addressDetails.filter(Boolean);
    return addressDetailsNotNull.join(", ");
  }

  get contactNumberHref() {
    const { contactNumber } = this.shop;
    return contactNumber && `tel:${contactNumber}`;
  }

  get contactEmailHref() {
    const { contactEmail } = this.shop;
    return contactEmail && `mailto:${contactEmail}`;
  }
}
